export const attackDiagram = () => {};
